export default __webpack_public_path__ + "static/9pros-f04aba8ac07298c30641aa06df3de631.png";